import React, { useEffect, useRef } from 'react';
import { RowDiv, Text, theme } from 'styles';
import styled from 'styled-components';
import { Icon } from 'components/common/Icon';
import { Button } from 'components/button/Button';
import ModalContainer from './ModalContainer';
import { Dim } from './Dim';

export function Modal({ open, title, children, cancel, submit }) {
  const conRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      if (conRef.current) {
        conRef.current.scrollTop = 0;
      }
    }, 0);
  }, [open]);

  return (
    <>
      <Dim open={open}>
        <ModalContainer>
          <div className="title">
            <Icon name="Info" $pathFill="primary100" />
            <Text $type="m18" $color="normal">
              {title}
            </Text>
          </div>
          <div className="con" ref={conRef}>
            {children}
            <RowDiv $marginTop={32} $gap={8} $justifyContent="flex-end">
              <Button $size="default" $type="sub" onClick={cancel}>
                취소
              </Button>
              <Button $size="default" onClick={submit}>
                확인
              </Button>
            </RowDiv>
          </div>
        </ModalContainer>
      </Dim>
    </>
  );
}